export default {
  // tasksList:null,
  tasksListColumns:null,
  taskStatus: null,
  taskPriority: null,
  addTask: null,
  editTask:null,
  updateTask:null,
  taskTeamMember:null,
  taskCategory:{
    business:null,
    premium:null
  },
  incompleteAllTask:null,
  completedAllTask:null,
  completionSeries:null,
  completionOptions:null,
  addTaskSuccess: null,
  latestTask: null,
  taskPermissions:null,
  allTaskStatus:null,
  completeTaskRate:null,
  taskComplete:[],
  showTaskModalData:null,
  editTaskState:null,
  taskRoute: localStorage.getItem('taskRoute')
}